module.exports = __webpack_public_path__ + "c86636e2050b6a423537d07d0cb2bfcd.svg";